// graphql-response.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoadingService } from 'app/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  operationNameBlacklist = [
    'productLineVariable',
    'productPositionsAssignments',
    'valueTexts',
    'minicartReferences',
    'materialAndEanCodes',
    'customers',
    'branches',
    'objects',
    'templates',
    'accounts',
    'articles',
    'contactPersons',
    'categoriesWithArticlesOnlyFromOrganization',

    // Dashboard
    'dashboardRevisions',

    // calculation page
    'accountPreferences',
    'setAccountPreference',
    //'quoteWithLinesCustomProps',
    'revisionsForOffer',

    // single items
    'branch',
    'account',
    'article',
    'customer',
    'object',
    'template',
    'contactPerson'
  ];

  constructor(
    private loadingService: LoadingService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.body) {
      const isException = this.operationNameBlacklist.includes(req.body.operationName);
      if (!isException) {
        this.loadingService.show();
      }
    }

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const isException = this.operationNameBlacklist.includes(req?.body?.operationName);
            if (!event.url?.includes('assets') && !isException) {
              this.loadingService.hide();
            }
          }
        },
        error: (_error) => {
          this.loadingService.hide(); // Hide on error as well
        },
      })
    );
  }
}
